import gsap from 'gsap'
import { bp, mm, sel, selAll, stResizeObserver } from './utils'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(SplitText, ScrollTrigger)

export default function Exec() {
  // window.addEventListener('load', function () {
  document.fonts.load('1rem "DM Sans"').then(() => {
    // console.log('Epic.js loaded')
    const navbarW$ = sel('.navbar-a')
    const navbar$ = sel('#navbar')
    const hero$ = sel('.hero')
    gsap.set(hero$, { zIndex: 30 })
    // const compInfo$ = header$.querySelector('.hero__info--epic')
    const heroP$ = hero$.querySelector('.hero__p--epic')
    const heroBtn1$ = hero$.querySelectorAll('.btn')[0]
    const heroBtn2$ = hero$.querySelectorAll('.btn')[1]

    const heroBg$ = hero$.querySelector('.hero__bg-w-w--epic')
    const heroBgImg$ = sel('.hero__epic-webp-w')
    const heroTag$ = hero$.querySelector('.hero__tag--epic')

    const compHsT = SplitText.create('.h1--epic', { type: 'words,chars' }) // words to keep the initial wrapping

    const epicSvgW$ = sel('.epic--hero--img')

    mm.add(bp.tabUp, () => {
      gsap.to(heroBgImg$, { rotate: -360, transformOrigin: 'center', duration: 300, repeat: -1, ease: 'none' })
      // gsap.to(heroBgPath$, { rotate: -360, transformOrigin: 'center', duration: 300, repeat: -1, ease: 'none' })

      gsap
        .timeline({ defaults: { ease: 'power4.out', duration: 2 } })
        .from(
          compHsT.chars,
          {
            autoAlpha: 0,
            filter: 'blur(50px)',
            stagger: 0.03,
            duration: 0.5,
            ease: 'none',
          },
          0
        )
        .from(heroP$, { autoAlpha: 0, y: -20, duration: 2 }, '>-0.5')
        .from(heroBtn1$, { autoAlpha: 0, y: -20 }, '<0.3')
        .from(heroBtn2$, { autoAlpha: 0, y: -20 }, '<0.1')
        .from(heroTag$, { autoAlpha: 0 }, '<+0.15')
        .from(navbar$, { opacity: 0, duration: 2.5, ease: 'none' }, '<-1')
        .from(heroBg$, { autoAlpha: 0, duration: 10, ease: 'none' }, '<50%')
    })

    const intro$ = sel('.epic-intro-sec')
    const introBg$ = sel('.epic-intro__bg-w')
    const introVidBg$ = sel('.epic-intro__vid-bg-w')
    const introH$ = intro$.querySelector('h2')
    const introHsT = SplitText.create(introH$, { type: 'chars, words' })
    // const introHsT = SplitText.create(introH$, { type: 'chars, words, lines', linesClass: 'st-line', mask: 'lines' })
    gsap.set(hero$, { marginBottom: '-100vh' })
    const introTl = gsap
      .timeline({ defaults: { ease: 'none', duration: 2 } })
      .from(introBg$, { scale: 1.2, autoAlpha: 0, ease: 'power1.out', duration: 7 })
      .from(
        introHsT.chars,
        {
          autoAlpha: 0,
          filter: 'blur(50px)',
          stagger: {
            each: 0.04,
          },
          duration: 1.5,
        },
        0.5
      )
      .from(intro$, { marginBottom: '-100vh' }, 5)
    ScrollTrigger.create({
      trigger: hero$,
      start: 'top top+=1',
      end: '300%',
      // end: 'top top',
      // end: 'top+=' + vh(50) + ' top',
      // end: '+=' + vh(100),
      scrub: true,
      pin: intro$,
      animation: introTl,
      onUpdate: (self) => {
        // Update the intro section's position based on the scroll progress
        const progress = self.progress
        // console.log('Scroll progress:', progress)
        // gsap.set(intro$, { y: `${progress * 100}vh` });
        if (progress > 50) {
        }
      },
    })

    const epic$ = sel('.epic-props-sec')
    const testW$ = sel('.epic-test-sec-w')
    const test$ = sel('.epic-test-sec')
    const testC$ = sel('.epic-test__c')
    const testA$ = test$.querySelector('.btn')
    const tableW$ = sel('.epic-table-sec-w')
    const table$ = sel('.epic-table-sec')
    gsap.set(test$, { marginTop: '-100vh' })
    // gsap.set(test$, { marginTop: '-100vh', marginBottom: '-100vh' })

    const testTl = gsap.timeline({ defaults: { ease: 'none', duration: 1 } })
    ScrollTrigger.create({
      trigger: epic$,
      start: 'bottom bottom',
      end: '+=100%',
      // end: '+=200%',
      scrub: true,
      pin: test$,
      // pinSpacing: false,
      // animation: testTl,
    })

    // Table
    const tableTab$a = selAll('.epic-table__col.is--header')
    tableTab$a.forEach((tab$) => {
      const tabColClass = tab$.dataset.col
      // console.log('tabColClass', tabColClass)

      tab$.addEventListener('click', function () {
        // console.log('tabColClass', tabColClass)
        tableTab$a.forEach((tab$) => {
          if (this === tab$) return
          tab$.classList.remove('is--active')
          this.classList.add('is--active')

          const dataClass = this.dataset.col
          const dataItem$a = selAll('.epic-table__col.is--data')
          dataItem$a.forEach((item$) => {
            if (item$.classList.contains(dataClass)) {
              item$.style.display = 'flex'
            } else {
              item$.style.display = 'none'
            }
          })
        })
      })
    })

    const tableTable$ = sel('.epic-table')
    const tableCol1Cell$a = selAll('.epic-table__col.is--1')
    const tableCol2Cell$a = selAll('.epic-table__col.is--2')
    const tableCol3Cell$a = selAll('.epic-table__col.is--3')
    const tableCol4Cell$a = selAll('.epic-table__col.is--4')
    const rowTw = {
      x: 10,
      autoAlpha: 0,
      stagger: 0.1,
      ease: 'power1.out',
    }
    const tableTl = gsap
      .timeline({ defaults: { ease: 'none', duration: 1 } })
      .from(tableCol1Cell$a, rowTw, 0)
      .from(tableCol2Cell$a, rowTw, 0)
      .from(tableCol3Cell$a, rowTw, 0)
      .from(tableCol4Cell$a, rowTw, 0)
    ScrollTrigger.create({
      trigger: tableTable$,
      start: 'top 60%',
      // end: '+=100%',
      // scrub: true,
      //
      toggleActions: 'play none none reverse',
      animation: tableTl,
    })

    const cta$ = sel('.epic-cta-sec')
    const ctaH$ = cta$.querySelector('h2')
    const ctaHsT$ = SplitText.create(ctaH$, { type: 'words, chars' })
    const ctaP$ = cta$.querySelector('.epic-cta__info>div:not(.button-group)')
    const ctaBtn$ = cta$.querySelector('.btn')
    const ctaBgWW$ = cta$.querySelector('.epic-cta__bg-w-w')
    const ctaBg$ = cta$.querySelector('.epic-cta__bg-w')
    const ctaBgBg$ = cta$.querySelector('.epic-cta__bg__img.is--bg')
    const ctaSvgBgW$ = cta$.querySelector('.epic-cta__svg-w')
    const ctaSvgBg$ = cta$.querySelector('.epic-cta__svg')
    const footer$ = sel('.footer')

    mm.add(bp.tabUp, () => {
      const ctaTl = gsap
        .timeline({ defaults: { ease: 'power3.out', duration: 1 } })
        //
        .from(
          ctaHsT$.chars,
          {
            autoAlpha: 0,
            filter: 'blur(50px)',
            stagger: 0.03,
            ease: 'none',
          },
          0
        )
        .from(ctaP$, { autoAlpha: 0, y: -20 }, '<50%')
        .from(ctaBtn$, { autoAlpha: 0, y: -20 }, '<10%')
        .from(footer$, { y: 20, autoAlpha: 0, duration: 3 }, '<10%')
        .from(ctaBgWW$, { autoAlpha: 0, y: -10, duration: 10 }, '<20%')

      ScrollTrigger.create({
        trigger: cta$,
        start: 'top 80%',
        // end: '+=100%',
        // scrub: true,
        animation: ctaTl,
        toggleActions: 'play none none reverse',
      })
      const ctaBgTl = gsap.timeline({ defaults: { ease: 'none', duration: 1 } }).fromTo(ctaBg$, { y: 0 }, { y: '15vh' })
      gsap.to(ctaBgBg$, { autoAlpha: 0.5, duration: 3, repeat: -1, yoyo: true })
      ScrollTrigger.create({
        trigger: cta$,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        animation: ctaBgTl,
      })
    })
    stResizeObserver()
    // console.log('Epic.js executed')
  })
}
